import api from "./api";

export const getAuditLogs = async (params = {}) => {
  const { data } = await api.get("/admin/v1/audit", { params });
  return data;
};

export const getAuditLog = async (id) => {
  const { data } = await api.get(`/admin/v1/audit/${id}`);
  return data;
};
